import React, { useEffect, useState } from 'react';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Typography, CircularProgress,
    Button,
    Modal,
    Box
} from '@mui/material';
import axios from 'axios';
import { API_ENDPOINT } from '../../../services/api/resources';
import HeaderTitle from '../../../components/common/HeaderTitle/HeaderTitle';
import Logo from "../../../assets/images/svg/Logo.svg";
import ImgFrame from '../../../components/common/ImageFrame/ImgFrame';
import classes from "../../TabStyles/DashboardTab.module.css";
import TablePagination from '@mui/material/TablePagination';





const MerchantInvoiceDelayTable = () => {
    const [rows, setRows] = useState([]);
    const [selectedSummary, setSelectedSummary] = useState("");


    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);



    useEffect(() => {
        axios.post(API_ENDPOINT.merchant_invoice_delay_tracker)
            .then(res => {
                setRows(res.data || []);
            })
            .catch(err => {
                console.error('Failed to fetch data:', err);
            })
            .finally(() => setLoading(false));
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    // const getSummaryText = (row) => {
    //     console.log(row)
    //     const totalDays = row.total_processing_days
    //     const merchantDelay = row.merchant_delay_days
    //     const bfDelayDays = row.bf_delay_days ?? 0
    //     const apDelayDays = row.bf_delay_days ?? 0



    //     const payeeDelay = bfDelayDays + apDelayDays
    //     const payeePercent = totalDays ? Math.round((payeeDelay / totalDays) * 100) : 0
    //     const merchantPercent = totalDays ? Math.round((merchantDelay / totalDays) * 100) : 0

    //     return `
    //     Invoice No. ${row.invoice_no}, dated "${row.invoice_date}", was generated and made ready on "${row.invoice_date}" for the merchant to review the proposed settlement amount. As part of the self-invoicing process, the merchant was expected to e-sign and formally accept the invoice to initiate the internal payment workflow.

    //     The merchant completed this step by providing their e-signature and accepting the invoice on "${row.esign_date}". 
    //     This acceptance automatically triggered the approval workflow within the payee organization. 
    //     The invoice was first routed to the Business Finance team and received their approval on "${row.business_finance_approval}". 
    //     Subsequently, it was forwarded to the Accounts Payable (AP) Team, who completed the final approval and initiated payment processing on "${row.ap_team_approval}".

    //     From the date the invoice was originally generated to the final approval by the AP Team, the total processing time was ${totalDays} days.

    //     On analyzing the delay contributors:

    //     The merchant took ${merchantDelay} days to e-sign and approve the invoice after it was made ready.

    //     The Business Finance team took ${bfDelayDays} days to complete their review and provide approval.

    //     The AP Team added a further ${apDelayDays} days before releasing the payment.

    //     In terms of accountability and performance measurement:

    //     Payee-side delay, which includes Business Finance and AP Team actions, accounted for ${payeePercent}% of the total time taken.

    //     Merchant-side delay, primarily due to delay in e-signing, contributed ${merchantPercent}% of the overall processing time.

    //     This breakdown helps highlight areas where improvements in responsiveness can significantly accelerate payment cycles and reduce the risk of merchant dissatisfaction or attrition.
    //     `;
    // };

    const getSummaryText = (row) => {
        const totalDays = row.total_processing_days;
        const merchantDelay = row.merchant_delay_days;
        const bfDelayDays = row.bf_delay_days ?? 0;
        const apDelayDays = row.ap_delay_days ?? 0;

        const payeeDelay = bfDelayDays + apDelayDays;
        const payeePercent = totalDays ? Math.round((payeeDelay / totalDays) * 100) : 0;
        const merchantPercent = totalDays ? Math.round((merchantDelay / totalDays) * 100) : 0;

        return `
        Invoice No. <strong>${row.invoice_no}</strong>, dated <strong>${row.invoice_date}</strong>, was generated and made ready on <strong>${row.invoice_date}</strong> for the merchant to review the proposed settlement amount. As part of the self-invoicing process, the merchant was expected to e-sign and formally accept the invoice to initiate the internal payment workflow.

        The merchant completed this step by providing their e-signature and accepting the invoice on <strong>${row.esign_date}</strong>.This acceptance automatically triggered the approval workflow within the payee organization.<br/>
        The invoice was first routed to the Business Finance team and received their approval on <strong>${row.business_finance_approval}</strong>.Subsequently, it was forwarded to the Accounts Payable (AP) Team, who completed the final approval and initiated payment processing on <strong>${row.ap_team_approval}</strong>. From the date the invoice was originally generated to the final approval by the AP Team, the <strong>total processing time was ${totalDays} days</strong>.

        <strong><u>On analyzing the delay contributors:</u></strong>

        The merchant took <strong>${merchantDelay} days</strong> to e-sign and approve the invoice after it was made ready.The Business Finance team took <strong>${bfDelayDays} days</strong> to complete their review and provide approval.The AP Team added a further <strong>${apDelayDays} days</strong> before releasing the payment.

        <strong><u>In terms of accountability and performance measurement:</u></strong>

        Payee-side delay, which includes Business Finance and AP Team actions, accounted for <strong>${payeePercent}%</strong> of the total time taken.Merchant-side delay, primarily due to delay in e-signing, contributed <strong>${merchantPercent}%</strong> of the overall processing time.
        This breakdown helps highlight areas where improvements in responsiveness can significantly accelerate payment cycles and reduce the risk of merchant dissatisfaction or attrition.
    `;
    };

    return (
        <>

            <HeaderTitle titleText={"Merchant Payment Delay & Analysis"} />

            <TableContainer component={Paper} sx={{ mt: 2, p: 2 }}>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 600 }}>Merchant</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 600 }}>Invoice Date</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 600 }}>E-Sign Date</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 600 }}>BF Approval</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 600 }}>AP Approval</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 600 }}>Merchant Delay (days)</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 600 }}>Total Processing Time (days)</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: 600 }}>Summary</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{ fontSize: '14px' }}>{row.merchant}</TableCell>
                                        <TableCell sx={{ fontSize: '14px' }}>{row.invoice_date}</TableCell>
                                        <TableCell sx={{ fontSize: '14px' }}>{row.esign_date}</TableCell>
                                        <TableCell sx={{ fontSize: '14px' }}>{row.business_finance_approval}</TableCell>
                                        <TableCell sx={{ fontSize: '14px' }}>{row.ap_team_approval}</TableCell>
                                        <TableCell sx={{ fontSize: '14px' }}>{row.merchant_delay_days}</TableCell>
                                        <TableCell sx={{ fontSize: '14px' }}>{row.total_processing_days}</TableCell>
                                        <TableCell>
                                            {(row.merchant_delay_days > 0 || row.bf_delay_days > 0 || row.ap_delay_days > 0) && <Button variant="contained" onClick={() => {
                                                setSelectedSummary(getSummaryText(row));
                                                setModalOpen(true);
                                            }}>View Summary</Button>}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            count={rows.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{ '& .MuiTablePagination-toolbar': { fontSize: '12px' }, '& .MuiTablePagination-selectLabel': { fontSize: '12px' }, '& .MuiTablePagination-select': { fontSize: '12px' }, '& .MuiTablePagination-displayedRows': { fontSize: '12px' } }}
                        />
                    </>

                )}
            </TableContainer>

            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                <Box sx={{
                    position: 'absolute',
                    top: '55%',
                    left: '49%',
                    transform: 'translate(-50%, -50%)',
                    width: 1000,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 2,
                    borderRadius: 2,
                    maxHeight: '81vh',
                    overflow: 'auto'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px', background: '#e9e9e9', borderRadius: '5px' }}>
                        <Typography variant="h6" gutterBottom sx={{ fontSize: '14px', fontWeight: '600' }}>Merchant Payment Delay & Analysis</Typography>
                        <img src={Logo} width={"100"} />
                    </div>
                    <Typography variant="body2" dangerouslySetInnerHTML={{ __html: selectedSummary }} style={{ whiteSpace: 'pre-line' }} sx={{ fontSize: '12px' }} />
                    <Box mt={2} textAlign="right">
                        <Button onClick={() => setModalOpen(false)} variant="contained">Close</Button>
                    </Box>
                </Box>
            </Modal>

        </>
    );
};

export default MerchantInvoiceDelayTable;
